"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Streem API
 * The Streem API gives you access to information captured during Streem calls.  You can retrieve artifacts such as recordings, streemshots (including captured model/serial numbers), and much more.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: support@streem.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.StreemApiGroupReservationReservationStatus = exports.StreemApiGroupReservationToJSON = exports.StreemApiGroupReservationFromJSONTyped = exports.StreemApiGroupReservationFromJSON = void 0;
const runtime_1 = require("../runtime");
const _1 = require("./");
function StreemApiGroupReservationFromJSON(json) {
    return StreemApiGroupReservationFromJSONTyped(json, false);
}
exports.StreemApiGroupReservationFromJSON = StreemApiGroupReservationFromJSON;
function StreemApiGroupReservationFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'companySid': !(0, runtime_1.exists)(json, 'company_sid') ? undefined : json['company_sid'],
        'group': !(0, runtime_1.exists)(json, 'group') ? undefined : (0, _1.StreemApiGroupFromJSON)(json['group']),
        'reservationSid': !(0, runtime_1.exists)(json, 'reservation_sid') ? undefined : json['reservation_sid'],
        'externalUserId': !(0, runtime_1.exists)(json, 'external_user_id') ? undefined : json['external_user_id'],
        'priority': !(0, runtime_1.exists)(json, 'priority') ? undefined : json['priority'],
        'reserveForSeconds': !(0, runtime_1.exists)(json, 'reserve_for_seconds') ? undefined : json['reserve_for_seconds'],
        'reservationStatus': !(0, runtime_1.exists)(json, 'reservation_status') ? undefined : json['reservation_status'],
        'queuePosition': !(0, runtime_1.exists)(json, 'queue_position') ? undefined : json['queue_position'],
        'reservedUser': !(0, runtime_1.exists)(json, 'reserved_user') ? undefined : (0, _1.StreemApiUserFromJSON)(json['reserved_user']),
        'reservedUntil': !(0, runtime_1.exists)(json, 'reserved_until') ? undefined : (new Date(json['reserved_until'])),
        'connectedAt': !(0, runtime_1.exists)(json, 'connected_at') ? undefined : (new Date(json['connected_at'])),
        'completedAt': !(0, runtime_1.exists)(json, 'completed_at') ? undefined : (new Date(json['completed_at'])),
        'details': !(0, runtime_1.exists)(json, 'details') ? undefined : (json['details'].map(_1.StreemApiGroupReservationDetailFromJSON)),
        'roomSid': !(0, runtime_1.exists)(json, 'room_sid') ? undefined : json['room_sid'],
        'initiatedAt': !(0, runtime_1.exists)(json, 'initiated_at') ? undefined : (new Date(json['initiated_at'])),
        'failedAt': !(0, runtime_1.exists)(json, 'failed_at') ? undefined : (new Date(json['failed_at'])),
        'expiredAt': !(0, runtime_1.exists)(json, 'expired_at') ? undefined : (new Date(json['expired_at'])),
        'requestedAt': !(0, runtime_1.exists)(json, 'requested_at') ? undefined : (new Date(json['requested_at'])),
        'estimatedWaitUntil': !(0, runtime_1.exists)(json, 'estimated_wait_until') ? undefined : (new Date(json['estimated_wait_until'])),
        'referenceId': !(0, runtime_1.exists)(json, 'reference_id') ? undefined : json['reference_id'],
        'integrationId': !(0, runtime_1.exists)(json, 'integration_id') ? undefined : json['integration_id'],
        'reconnectPreviousReservationSid': !(0, runtime_1.exists)(json, 'reconnect_previous_reservation_sid') ? undefined : json['reconnect_previous_reservation_sid'],
        'callDetail': !(0, runtime_1.exists)(json, 'call_detail') ? undefined : (0, _1.StreemApiCallDetailFromJSON)(json['call_detail']),
    };
}
exports.StreemApiGroupReservationFromJSONTyped = StreemApiGroupReservationFromJSONTyped;
function StreemApiGroupReservationToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'company_sid': value.companySid,
        'group': (0, _1.StreemApiGroupToJSON)(value.group),
        'reservation_sid': value.reservationSid,
        'external_user_id': value.externalUserId,
        'priority': value.priority,
        'reserve_for_seconds': value.reserveForSeconds,
        'reservation_status': value.reservationStatus,
        'queue_position': value.queuePosition,
        'reserved_user': (0, _1.StreemApiUserToJSON)(value.reservedUser),
        'reserved_until': value.reservedUntil === undefined ? undefined : (value.reservedUntil.toISOString()),
        'connected_at': value.connectedAt === undefined ? undefined : (value.connectedAt.toISOString()),
        'completed_at': value.completedAt === undefined ? undefined : (value.completedAt.toISOString()),
        'details': value.details === undefined ? undefined : (value.details.map(_1.StreemApiGroupReservationDetailToJSON)),
        'room_sid': value.roomSid,
        'initiated_at': value.initiatedAt === undefined ? undefined : (value.initiatedAt.toISOString()),
        'failed_at': value.failedAt === undefined ? undefined : (value.failedAt.toISOString()),
        'expired_at': value.expiredAt === undefined ? undefined : (value.expiredAt.toISOString()),
        'requested_at': value.requestedAt === undefined ? undefined : (value.requestedAt.toISOString()),
        'estimated_wait_until': value.estimatedWaitUntil === undefined ? undefined : (value.estimatedWaitUntil.toISOString()),
        'reference_id': value.referenceId,
        'integration_id': value.integrationId,
        'reconnect_previous_reservation_sid': value.reconnectPreviousReservationSid,
        'call_detail': (0, _1.StreemApiCallDetailToJSON)(value.callDetail),
    };
}
exports.StreemApiGroupReservationToJSON = StreemApiGroupReservationToJSON;
/**
* @export
* @enum {string}
*/
var StreemApiGroupReservationReservationStatus;
(function (StreemApiGroupReservationReservationStatus) {
    StreemApiGroupReservationReservationStatus["QUEUED"] = "GROUP_RESERVATION_STATUS_QUEUED";
    StreemApiGroupReservationReservationStatus["CANCELED"] = "GROUP_RESERVATION_STATUS_CANCELED";
    StreemApiGroupReservationReservationStatus["MATCHED"] = "GROUP_RESERVATION_STATUS_MATCHED";
    StreemApiGroupReservationReservationStatus["CONNECTED"] = "GROUP_RESERVATION_STATUS_CONNECTED";
    StreemApiGroupReservationReservationStatus["EXPIRED"] = "GROUP_RESERVATION_STATUS_EXPIRED";
    StreemApiGroupReservationReservationStatus["NOTMATCHED"] = "GROUP_RESERVATION_STATUS_NOT_MATCHED";
    StreemApiGroupReservationReservationStatus["COMPLETED"] = "GROUP_RESERVATION_STATUS_COMPLETED";
    StreemApiGroupReservationReservationStatus["CONFIRMING"] = "GROUP_RESERVATION_STATUS_CONFIRMING";
    StreemApiGroupReservationReservationStatus["INITIATED"] = "GROUP_RESERVATION_STATUS_INITIATED";
    StreemApiGroupReservationReservationStatus["FAILED"] = "GROUP_RESERVATION_STATUS_FAILED";
    StreemApiGroupReservationReservationStatus["INVALID"] = "GROUP_RESERVATION_STATUS_INVALID";
})(StreemApiGroupReservationReservationStatus = exports.StreemApiGroupReservationReservationStatus || (exports.StreemApiGroupReservationReservationStatus = {}));
//# sourceMappingURL=StreemApiGroupReservation.js.map